<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">

                                        <div class="page-body">
                                            <h4>Archived Applications</h4>

                                            <div class="table-responsive">
                                                <input type="text" class="form-control" v-model="starred_filter" placeholder="Search...">
                                                <datatable :columns="starred_columns" :data="starred_rows" :filter-by="starred_filter" name="openings_table"></datatable>
                                                <div class="" style="text-align: center;">
                                                    <datatable-pager v-model="page" type="long" :per-page="per_page" table="openings_table"></datatable-pager>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<style>
    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        background: #d5d5d5 !important;
    }

    .pagination a.active{
        background: #4CAF50 !important;
        color: white;
    }

    .pagination a:hover:not(.active) {background-color: #00ff00;}
</style>
<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'

export default {
    name: 'StarredApplications',

    data(){
        return{
            starred_filter: '',
            page: 1,
            per_page: 10,
            starred_columns: [
                {label: 'ID', field: 'id'},
                {label: 'Applicant Name', field: 'applicant_name'},
                {label: 'Date Archived', field: 'date_starred', sortable: false},
                {label: 'Reason', field: 'reason', sortable: false},
                {label: 'Action', representedAs:(row)=>{
                    return '<a class="btn btn-sm btn-success" href="/opening/' + row.joblisting_id + '/application/' + row.applicant_id + '">View</button>'
                }, interpolate:true, sortable: false},
            ],

            starred_rows: [
                {
                    id: 'Loading...',
                    date_starred: 'Loading...',
                    reason: 'Loading...'
                }
            ]
        }
    },

    components:{
        navbar1,
        navbar2
    },

    mounted(){
    	$('.theme-loader').hide()

    	this.getStarredApplications()

        //this.getRoleNameById('23')
    },
    methods: {

    	getStarredApplications(){

    		var starred_applications = {
    			what: 'StarredApplications'
    		}

    		this.$socket.makeGetRequest(starred_applications)
    			.then((response)=>{
    				if(response.type == 'StarredApplications'){
    					console.log(response.data)
    					this.starred_rows = response.data
    				}
    			})
    			.catch((e)=>{
    				console.log(e)
    			})
    	}
    },
    computed: {
        
    }
}
</script>
